import { render, staticRenderFns } from "./clientRow.vue?vue&type=template&id=f060158c&"
import script from "./clientRow.vue?vue&type=script&lang=js&"
export * from "./clientRow.vue?vue&type=script&lang=js&"
import style0 from "./clientRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "clientRow.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VDialog,
})
